// extracted by mini-css-extract-plugin
export default {"routerOutlet":"Layout_routerOutlet__lyrL9","header":"Layout_header__05R8D"};